export const xeroBudgetCheckingHelpStripeId = 'budget-checking-xero';
export const qBooksBudgetCheckingHelpStripeId = 'budget-checking-qbooks';
